'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import Script from 'next/script';
import { useEffect } from 'react';

import { mindboxPopupFormTracking } from './mindboxPopupFormTracking';

interface ScriptMindboxProps {
  endpointId?: string;
}

export const ScriptMindbox = ({ endpointId }: ScriptMindboxProps) => {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    return mindboxPopupFormTracking();
  }, []);

  useEffect(() => {
    window.PopMechanic?.update?.();
  }, [pathname, searchParams]);

  const handleLoad = () => {
    window.PopMechanic = { watchLocation: false };
    window.mindbox =
      window.mindbox ||
      function (...args: unknown[]) {
        window.mindbox.queue.push(args);
      };
    window.mindbox.queue = window.mindbox.queue || [];
    window.mindbox('create', {
      endpointId,
      cookieSettings: {
        sameSite: 'none',
        secure: process.env.NODE_ENV === 'production'
      }
    });
  };

  return (
    <Script
      src="https://api.mindbox.ru/scripts/v1/tracker.js"
      async
      onLoad={handleLoad}
    />
  );
};
